import {
  UserMeResponse,
  UserUpdatePreferenceRequest,
  UserUpdatePreferenceResponse,
} from '@quromedical/models';
import { trpc } from 'trpc';

export class UserPreferenceApi {
  public registerPushToken = async (pushTokenId: string): Promise<void> => {
    await trpc.client.user.addPushToken.mutate({ pushTokenId });
  };

  public unregisterPushToken = async (pushTokenId: string): Promise<void> => {
    await trpc.client.user.removePushToken.mutate({ pushTokenId });
  };

  public getMe = async (): Promise<UserMeResponse> => {
    return await trpc.client.practitioner.getProfile.query();
  };

  public updatePreference = async (
    body: UserUpdatePreferenceRequest
  ): Promise<UserUpdatePreferenceResponse> => {
    const result = await trpc.client.practitioner.updateUserPreferences.mutate(body);

    return { theme: result.theme };
  };
}
